module.exports = __webpack_public_path__ + "img/recommend.c1824b53.jpg";